import { useTranslation } from 'react-i18next';
import { createElement, useState } from 'react';
import { TypeSmallIconCards } from '../form/form-fields/TypeSmallIconCards';
import ShortTextIcon from '@mui/icons-material/ShortText';
import NumbersIcon from '@mui/icons-material/Numbers';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import { NewMatchingPropertyText } from '../exo/matching-properties/NewMatchingPropertyText';
import { Box } from '@mui/material';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { NewMatchingPropertyNumber } from '../exo/matching-properties/NewMatchingPropertyNumber';
import { NewMatchingPropertyCheckbox } from '../exo/matching-properties/NewMatchingPropertyCheckbox';
import { NewMatchingPropertySelect } from '../exo/matching-properties/NewMatchingPropertySelect';

export const NewMatchingProperty = ({
  onUpdate,
  onCreate,
  startData,
  onClose,
  onFeedback,
  salesLevelId,
  startType,
}) => {
  const { t } = useTranslation();
  const [selectedType, setSelectedType] = useState(startType || {});

  function handleChange(key, data) {
    setSelectedType(data);
  }

  const typeMap = {
    text: NewMatchingPropertyText,
    number: NewMatchingPropertyNumber,
    checkbox: NewMatchingPropertyCheckbox,
    select: NewMatchingPropertySelect,
  };

  function handleUpdate(data) {
    onClose();
    onUpdate(data);
  }
  function handleCreate(data) {
    onClose();
    onCreate(data);
  }

  return (
    <Box className="flex flex-col w-full gap-3">
      <TypeSmallIconCards
        dataCollection={{ type: selectedType }}
        updateValidationOnChange={handleChange}
        field={{
          label: t('Type') + ':',
          key: 'type',
          cards: [
            {
              label: t('text'),
              Icon: ShortTextIcon,
              value: 'text',
            },
            {
              label: t('number'),
              Icon: NumbersIcon,
              value: 'number',
            },

            {
              label: t('yes/no'),
              Icon: CheckBoxIcon,
              value: 'checkbox',
            },
            {
              label: t('select'),
              Icon: FormatListBulletedIcon,
              value: 'select',
            },
          ],
        }}
      />
      {typeMap[selectedType] &&
        createElement(typeMap[selectedType], {
          onUpdate: handleUpdate,
          onCreate: handleCreate,
          startData,
          onClose,
          onFeedback,
          salesLevelId,
        })}
    </Box>
  );
};
